import Swiper from 'swiper';
import {Autoplay} from 'swiper/modules';
Swiper.use([Autoplay]);

const hero_posts = new Swiper('.blog-post__slider', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 20,
  autoplay: {
    delay: 5000
  }
});
